import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { sha256 } from 'js-sha256';
import servicioHttp from "../../servicio/ServicioHttp";
import servicioObjetos from "../../servicio/ServicioObjetos";
import { obtenerContenidoArchivo, obtenerTexto } from '../../servicio/ServicioCodificacionArchivos';

export const ZonaDropZone = (props) => {
    let { growl } = props;
    let { urlProcesoTxt, funcionProcesamiento, funcionGuardadoServidor, urlCrearMovimientos } = props;
    const [archivos, setArchivos] = useState(new Map());
    const [listaTXT, setListaTXT] = useState([]);
    const [mostrarModalConfirmacion, setMostrarModalConfirmacion] = useState(false);

    const onDrop = (files) => {
        for (var i = 0; i < files.length; i++) {
            obtenerContenidoArchivo(files[i]).then(archivoFinalResponse => {
                obtenerTexto(archivoFinalResponse).then(contenido => {
                    let llaveHas256Archivo = sha256(contenido);
                    actualizarMapa(llaveHas256Archivo, archivoFinalResponse);
                }).catch(error => {
                    console.log("Error al obtener texto:", error);
                });
            }).catch(error => {
                console.log(error);
            });
        }
    };

    const actualizarMapa = (llave, valor) => {
        setArchivos(new Map(archivos.set(llave, valor)));
    }

    const guardar = () => {
        if (archivos.size > 0) {
            growl.current.clear();
            let formData = new FormData();
            archivos.forEach((value, key) => {
                var cfdi = value;
                formData.append('recibos', cfdi, cfdi.name);
            });
            servicioHttp.consumirPostHttp(urlProcesoTxt, formData).then((response) => {
                let listaResultados = servicioObjetos.esObjetoVacio(response.data.objeto) ? [] : response.data.objeto;
                reiniciar();
                setListaTXT(listaResultados);
                funcionProcesamiento(listaResultados);
                growl.current.show({ severity: response.data.error ? 'error' : 'success', summary: response.data.error ? 'Error' : 'Exito', detail: response.data.mensaje, life: 15000 });
            }).catch((error) => {
                console.log("error:", error);
                growl.current.show({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error en el servidor, por favor vuelva a intentar.' });
            });
        }
    }

    const mostrarConfirmacion = () => {
        setMostrarModalConfirmacion(true);
    }

    const cerrarConfirmacion = () => {
        setMostrarModalConfirmacion(false);
    }

    const guardarMovimientos = () => {
        growl.current.clear();        
        cerrarConfirmacion();
        let listaEnvioFinal = [];
        for (let i = 0; i < listaTXT.length; i++) {
            let value = listaTXT[i];
            if (servicioObjetos.esObjetoVacio(value.errores))
                listaEnvioFinal.push(value);
        }

        servicioHttp.consumirPostHttp(urlCrearMovimientos, listaEnvioFinal).then((response) => {
            let procesamientoArchivosTxtWrapper=response.data.objeto;
            if (!servicioObjetos.esObjetoVacio(procesamientoArchivosTxtWrapper.errores)) {
                for (let i = 0; i < procesamientoArchivosTxtWrapper.errores.length; i++) {
                    let valor = procesamientoArchivosTxtWrapper.errores[i];
                    growl.current.show({ severity: 'error', summary: 'Error', detail: valor, sticky: true });
                }
            }

            if (!servicioObjetos.esObjetoVacio(procesamientoArchivosTxtWrapper.exitos)) {
                for (let i = 0; i < procesamientoArchivosTxtWrapper.exitos.length; i++) {
                    let valor = procesamientoArchivosTxtWrapper.exitos[i];
                    growl.current.show({ severity: 'success', summary: 'Éxito', detail: valor, sticky: true });
                }
            }
            setListaTXT([]);            
            funcionGuardadoServidor(response.data);
        }).catch((error) => {
            console.log("error:", error);
        });

    }

    const reiniciar = () => {
        setArchivos(new Map());
    }

    const dialogFooterConfirmacion = (
        <div>
            <Button icon="pi-md-check" onClick={guardarMovimientos} label="Si estoy seguro" className="p-button flat-btn" />
            <Button icon="pi-md-close" onClick={cerrarConfirmacion}
                label="No estoy seguro" className="p-button-danger flat-btn" />
        </div>
    );

    return (<div>
        <Dropzone accept=".txt" onDrop={onDrop}>
            {({ getRootProps, getInputProps }) => (
                <section >
                    <div  {...getRootProps({ className: 'dropzone rectangulo' })}>
                        <input   {...getInputProps()} />
                        <center><p>Arrastra tus archivos txt o da click aquí</p></center>
                    </div>
                    <br></br>
                    <Button label="Validar Archivos Txt" icon="pi-md-folder" onClick={guardar} />
                    {listaTXT.length > 0 ? <Button label="Guardar Archivos Txt" icon="pi-md-save" onClick={mostrarConfirmacion} /> : null}
                    <aside>
                        <h4>Cantidad de archivos a procesar</h4>
                        <ul>{archivos.size}</ul>
                    </aside>
                </section>
            )}
        </Dropzone>

        <Dialog appendTo={document.body} header="Confirmación"
            visible={mostrarModalConfirmacion} modal={true} style={{ width: "30vw" }}
            footer={dialogFooterConfirmacion} onHide={cerrarConfirmacion}>
            <h2>¿Estás seguro que deseas enviar los movimientos?</h2>
        </Dialog>
    </div>);
}